/** @format */

import React from 'react';
import { connect } from 'react-redux';
import CasesManagerConsentStatusPres from 'src/ui/features/Cases/presentational/CasesManagerConsentStatusPres';
import { setConsentStatus } from 'src/services/cases.service';

class CasesConsentStatusContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      consentStatusId: props.consentStatusId,
      disableUpdate: false,
    };
  }

  handleConsentStatusChange = consentStatusId => {
    this.setState({ consentStatusId: consentStatusId });
  };

  handleUpdate = async () => {
    this.setState({ disableUpdate: true });
    const { onRefreshDetails, caseManagerId } = this.props;
    let { consentStatusId } = this.state;

    const result = await setConsentStatus(caseManagerId, consentStatusId);

    if (result && result.success) {
      if (onRefreshDetails) await onRefreshDetails();
    }
    this.setState({ disableUpdate: false });
  };

  render() {
    return (
      <CasesManagerConsentStatusPres
        consentStatusId={this.state.consentStatusId}
        statusList={this.props.statusList}
        handleConsentStatusChange={this.handleConsentStatusChange}
        onUpdate={this.handleUpdate}
        disableUpdate={this.state.disableUpdate}
      />
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CasesConsentStatusContainer);
